import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Titulação',
  path: '/pessoal/pestipotitulacao',
  name: 'pestipotitulacao',
  component: () => import('@/views/pessoal/pestipotitulacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODETITULACAONOVO_MENU_1400800299],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Titulação',
  path: '/pessoal/pestipotitulacao/cadastro/:id?',
  parent: 'pestipotitulacao',
  name: 'pestipotitulacao_create',
  component: () => import('@/views/pessoal/pestipotitulacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODETITULACAONOVO_MENU_1400800299],
  },
  goesToMenu: true,
 },
]
